import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { StatisticsPageBase } from '@zero/statistics/feature-statistics/base';
import { DividendsComponent } from '../components/dividends/dividends.component';
import { MyChartComponent } from '../components/my-chart/my-chart.component';
import { MyNewsComponent } from '../components/my-news/my-news.component';
import { MyStatsComponent } from '../components/my-stats/my-stats.component';
import { MyTradesComponent } from '../components/my-trades/my-trades.component';
import { TradeTickerComponent } from '../components/trade-ticker/trade-ticker.component';
import { WeightingComponent } from '../components/weighting/weighting.component';

@Component({
  templateUrl: './statistics-page.component.html',
  imports: [
    CommonModule,
    TranslocoPipe,
    TradeTickerComponent,
    MyTradesComponent,
    WeightingComponent,
    MyNewsComponent,
    MyChartComponent,
    MyStatsComponent,
    DividendsComponent,
  ],
})
export class StatisticsPageComponent extends StatisticsPageBase implements OnInit, OnDestroy {
  ngOnInit(): void {
    this.load();
  }

  ngOnDestroy(): void {
    this.clean();
  }
}
